import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export type AppPage = 'cover' | 'hall' | 'era-select' | 'load-game' | 'profile' | 'game'

interface NavigationState {
  currentPage: AppPage
  previousPage: AppPage | null
  setCurrentPage: (page: AppPage) => void
  goBack: () => void
}

export const useNavigationStore = create<NavigationState>()(
  persist(
    (set, get) => ({
      currentPage: 'cover',
      previousPage: null,

      setCurrentPage: (page: AppPage) => {
        const { currentPage } = get()
        set({
          previousPage: currentPage,
          currentPage: page,
        })
      },

      goBack: () => {
        const { previousPage } = get()
        if (previousPage) {
          set({ currentPage: previousPage, previousPage: null })
        }
      },
    }),
    {
      name: 'game-navigation',
      partialize: (state) => ({
        currentPage: state.currentPage,
        previousPage: state.previousPage,
      }),
    }
  )
)
